import { keepPreviousData, QueryFunction, QueryKey, useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { useContext, useEffect } from 'react';

import { MembersContext } from '@/contexts/membersContext';
import mapAxiosErrorMessages from '@/utils/mapAxiosErrorMessages';

const useAPI = <TQueryFnData, TError = Error, TData = TQueryFnData>({
  enabled = true,
  queryKey,
  queryFn,
  refetchOnWindowFocus,
  select,
  staleTime,
  supressMessages = false
}: {
  enabled?: boolean;
  queryKey: QueryKey;
  queryFn: QueryFunction<TQueryFnData>;
  refetchOnWindowFocus?: boolean;
  select?: (data: TQueryFnData) => TData;
  staleTime?: number;
  supressMessages?: boolean;
}) => {
  const { addMessage } = useContext(MembersContext);

  const queryResponse = useQuery<TQueryFnData, TError, TData>({
    enabled,
    queryFn,
    queryKey,
    placeholderData: keepPreviousData,
    refetchOnWindowFocus,
    retry: false,
    select,
    staleTime
  });

  const { error, isError } = queryResponse;

  useEffect(() => {
    if (isError && !supressMessages) {
      addMessage(mapAxiosErrorMessages(error as AxiosError));
    }
  }, [addMessage, error, isError, supressMessages]);

  return queryResponse;
};

export default useAPI;
